import { Injectable, TemplateRef } from '@angular/core';
import { JhiAlert, JhiAlertService } from '../core-utils';

@Injectable({ providedIn: 'root' })
export class AlertService {

    constructor(private jhiAlertService: JhiAlertService) {
    }

    error(msg: string, params?: any, timeout?: number): JhiAlert {
        return this.jhiAlertService.addAlert({
            msg,
            params,
            type: 'danger',
            timeout: timeout || 8000,
            toast: true
        }, null);
    }

    errorAsTemplate(tpl: TemplateRef<any>, timeout?: number): JhiAlert {
        return this.jhiAlertService.addAlert({
            msg: '',
            params: null,
            type: 'danger',
            timeout: timeout ?? 8000,
            toast: true,
            template: tpl
        }, null);
    }

    success(msg: string, params?: any, timeout?: number): JhiAlert {
        return this.jhiAlertService.addAlert({
            msg,
            params,
            type: 'success',
            timeout: timeout || 5000,
            toast: true
        }, null);

    }

    warning(msg: string, params?: any, timeout?: number): JhiAlert {
        return this.jhiAlertService.addAlert({
            msg,
            params,
            type: 'warning',
            timeout,
            toast: true
        }, null);
    }

    closeAlert(index: number): void {
        this.jhiAlertService.closeAlert(index, this.jhiAlertService.get());
    }

    closeAllAlerts(): void {
        const alerts = this.jhiAlertService.get();
        if (alerts) {
            // Close alerts in reverse order to avoid index shifting issues
            for (let i = alerts.length - 1; i >= 0; i--) {
                this.jhiAlertService.closeAlert(i, alerts);
            }
        }
    }
}
